const styles = theme => ({
  form: {
    padding: '0 1em 1em 1em'
  },
  input: {
    marginTop: '1em'
  },
  textField: {
    width: 150,
    margin: 10
  },
  titleContainer: {
    justifyContent: 'flex-end'
  }
});

export default styles;
